// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"6":"9789d7a3","134":"fec55ff2","167":"8db92b67","198":"640df97c","281":"bb1fb293","357":"bcf75be2","412":"7629b487","420":"93998253","438":"6b0eccd4","496":"9304cf70","686":"9826485f","828":"6e1de098"}[chunkId] + ".chunk.js";
};